const utils = require('frontend-controller/lib/utils');

module.exports = {
	config: {
		subFormAliasContainer:	'children',
		subFormAlias: 			'um_users_scopeRoles',
		subFormPrimaryKey: 		'userScopeRoleID',
		scopeWhiteList: 		false
	},

	model: {
		toggleData: {},
		dirtyData: {},
		scopeRoleAssignmentResources: {}
	},

	methods: {
		sanitizeResources: function(){
			this.model.toggleData = {};

			if(this.resourceData && this.resourceData.data){
				var scope, scopeID, scopeIndex, scopeRole, scopeRoleID, scopeRoleIndex;
				for(scopeIndex in this.resourceData.data){
					scope = this.resourceData.data[scopeIndex];
					scopeID = scope.attributes[scope.primaryKey];

					if(!this.config.scopeWhiteList || this.config.scopeWhiteList[scope.attributes.name]){
						this.model.toggleData[scopeID] = {
							options: 	[
								{
									value: '',
									name: storage.__('dataValues.options.none')
								}
							],
							name: 		storage.__(`scopes.names.${scope.attributes.name}`)
						};

						if(scope.children && scope.children.um_scopeRoles && scope.children.um_scopeRoles.data){
							for(scopeRoleIndex in scope.children.um_scopeRoles.data){
								scopeRole 	= scope.children.um_scopeRoles.data[scopeRoleIndex];
								scopeRoleID = scopeRole.attributes[scopeRole.primaryKey]
								const scopeRoleConfig = scopeRole.attributes.config || {}
								if(!scopeRoleConfig.hideInOfficeTool){
									this.model.toggleData[scopeID].options.push({
										value: scopeRoleID,
										name: scopeRole.attributes.name
									});
								}
							}
						}
					}
				}
			}
		},

		selectScopeRoles: function(scopeRoles){
			var scopeRoleIndex,
				scopeRole,
				scopeRoleID,
				scopeID,
				availableScopeRoles,
				scopeRoleOptionIndex,
				scopeIdentified,
				$scopeToggle
			;

			for(scopeID in this.model.toggleData){
				availableScopeRoles = this.model.toggleData[scopeID];
				scopeIdentified = false;
				this.model.scopeRoleAssignmentResources[scopeID] = {};

				for(scopeRoleOptionIndex in availableScopeRoles.options){
					for(scopeRoleIndex in scopeRoles){
						scopeRole = scopeRoles[scopeRoleIndex].attributes;
						scopeRoleID = scopeRole.scopeRoleID;

						if(availableScopeRoles.options[scopeRoleOptionIndex].value == scopeRoleID){
							scopeIdentified = true;
							this.model.scopeRoleAssignmentResources[scopeID] = {};
							this.model.scopeRoleAssignmentResources[scopeID].scopeRoleID = scopeRoleID;
							this.model.scopeRoleAssignmentResources[scopeID][this.config.subFormPrimaryKey] = scopeRole[this.config.subFormPrimaryKey];

							if(($scopeToggle = this.$.find('[data-field-code="' + scopeID + '"]')).length > 0){
								getComponent($scopeToggle).select(scopeRoleID);
							}
							break;
						}
					}

					if(scopeIdentified){
						break;
					}
				}
			}
		},

		setTypeDependentDefaultScopeRole(mainForm){
			const scopesByComponentClass = {
				'templates_office_customerContacts_properties_propertiesForm': 'customers',
				'templates_office_contractorContacts_properties_propertiesForm': 'contractors',
			}

			for(const componentClass in scopesByComponentClass){
				if(mainForm.hasClass(componentClass)){
					let scope, scopeID, scopeAttributes, scopeIndex, scopeRole, scopeRoleID, scopeRoleIndex, $scopeToggle;
					for(scopeIndex in this.resourceData.data || []){
						scope = this.resourceData.data[scopeIndex]
						scopeID = scope.attributes[scope.primaryKey]
						scopeAttributes = scope.attributes || {}

						if(scopeAttributes.name === scopesByComponentClass[componentClass]){
							if(((scope.children || {}).um_scopeRoles || {}).data){
								for(scopeRoleIndex in scope.children.um_scopeRoles.data){
									scopeRole 	= scope.children.um_scopeRoles.data[scopeRoleIndex]
									scopeRoleID = scopeRole.attributes[scopeRole.primaryKey]
									const scopeRoleConfig = scopeRole.attributes.config || {}
									if(scopeRoleConfig.type === 'default'){
										if(($scopeToggle = this.$.find('[data-field-code="' + scopeID + '"]')).length > 0){
											getComponent($scopeToggle).select(scopeRoleID)
											return
										}
									}
								}
							}
						}
					}
				}
			}
		}
	},

	hooks: {
		attach: function($element, triggerOptions){
			this.locate('<< base_form_form', mainForm => {
				mainForm.setClean()

				if(!triggerOptions.refresh && mainForm.config.creationMode){
					this.setTypeDependentDefaultScopeRole(mainForm)
				}
			})

		},

		onChildChanged: function($element, triggerOptions){
			if(triggerOptions.fieldCode){
				if(!this.model.parentForm){
					this.closest('base_form_form', parentFormComponent => {
						this.model.parentForm = parentFormComponent;
					})
				}

				if(!this.model.parentForm.model.dirtyFields.data) 																	this.model.parentForm.model.dirtyFields.data = {};
				if(!this.model.parentForm.model.dirtyFields.data[this.config.subFormAliasContainer]) 								this.model.parentForm.model.dirtyFields.data[this.config.subFormAliasContainer] = {};
				if(!this.model.parentForm.model.dirtyFields.data[this.config.subFormAliasContainer][this.config.subFormAlias]) 		this.model.parentForm.model.dirtyFields.data[this.config.subFormAliasContainer][this.config.subFormAlias] = {};
				if(!this.model.parentForm.model.dirtyFields.data[this.config.subFormAliasContainer][this.config.subFormAlias].data) this.model.parentForm.model.dirtyFields.data[this.config.subFormAliasContainer][this.config.subFormAlias].data = [];

				var scopeRolesData = this.model.parentForm.model.dirtyFields.data[this.config.subFormAliasContainer][this.config.subFormAlias].data;
				var scopeRoleAssignment = this.model.scopeRoleAssignmentResources[triggerOptions.fieldCode] || {};

				// ready to change scopeRole
				if(scopeRoleAssignment.scopeRoleID != triggerOptions.value){

					// ready to remove old scopeRole
					if(scopeRoleAssignment[this.config.subFormPrimaryKey]){
						var deleteEntry = {
							attributes: {},
							type: 'delete'
						};
						deleteEntry.attributes[this.config.subFormPrimaryKey] = scopeRoleAssignment[this.config.subFormPrimaryKey];
						scopeRolesData.push(deleteEntry);
					}

					// ready to add scopeRole
					if(triggerOptions.value){
						scopeRolesData.push({
							attributes: {
								scopeRoleID: triggerOptions.value
							}
						});
					}

					const userForm = this.model.parentForm

					if(userForm.config.creationMode){
						userForm.config.submitAllResources = true
						if(!utils.isEmpty(userForm.model.globalStaticFields)){
							utils.forEach(userForm.model.globalStaticFields, (defaultValue, fieldCode) => {
								if(userForm.getFieldValue(fieldCode, 'dirty') === undefined){
									userForm.fieldToModel(fieldCode, defaultValue)
								}
							});
						}
					} else {
						userForm.fieldToModel('primaryKey')
					}
					userForm.closest('base_form_form', mainForm => {
						mainForm.subFieldsToModel(userForm.config.subFormAlias, userForm.model.dirtyFields, false, undefined, userForm.config.parentFormResourceKey, (userForm.config.availableSeparators || {}).type === 'single');
						mainForm.setDirty()
					})
				}
			}
		},

		employeeTypeChanged($element, options){
			const employeeType = options.type

			// set crew-scopeRole if necessary
			if(employeeType && (this.resourceData || {}).data){
				let scope, scopeID, scopeAttributes, scopeIndex, scopeRole, scopeRoleID, scopeRoleIndex, $scopeToggle;
				for(scopeIndex in this.resourceData.data){
					scope = this.resourceData.data[scopeIndex]
					scopeID = scope.attributes[scope.primaryKey]
					scopeAttributes = scope.attributes || {}

					if(scopeAttributes.name === 'crew'){
						if(((scope.children || {}).um_scopeRoles || {}).data){
							for(scopeRoleIndex in scope.children.um_scopeRoles.data){
								scopeRole 	= scope.children.um_scopeRoles.data[scopeRoleIndex]
								scopeRoleID = scopeRole.attributes[scopeRole.primaryKey]
								const scopeRoleConfig = scopeRole.attributes.config || {}
								if(scopeRoleConfig.employeeType === employeeType){
									if(($scopeToggle = this.$.find('[data-field-code="' + scopeID + '"]')).length > 0){
										getComponent($scopeToggle).select(scopeRoleID)
										return
									}
								}
							}
						}
					}
				}
			}
		},
	}
};
